// extracted by mini-css-extract-plugin
module.exports = {"container":"index_container_1mTWb","box":"index_box_k5BxE","title":"index_title_9YX4V","line":"index_line_1iRzo","login":"index_login_Er0jL","statement":"index_statement_2Nf6d"};